export const pathNamePages = {
  analisisDeudaCliente: "/analisisDeudaCliente",
  analisisDeudaProveedor: "/analisisDeudaProveedor",
  impresion: "/impresion",
  impresionVentas: "/impresion/ventas",
  impresionCompras: "/impresion/compras",
  pedidos: "/pedidos",
  presupuestos: "/presupuestos",
  cotizaciones: "/cotizaciones",
  ordenesCompra: "/ordenesCompra",
  smartScan: "/smartScan",
  home: "/",
  cliente: '/cliente',
  proveedor: '/proveedor',
};
